import { render, staticRenderFns } from "./FabArea.vue?vue&type=template&id=7f6e3bf9&scoped=true&"
var script = {}
import style0 from "./FabArea.vue?vue&type=style&index=0&id=7f6e3bf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6e3bf9",
  null
  
)

export default component.exports